import { Fragment, useState } from "react";
import { Dialog, Tab, Transition } from "@headlessui/react";
import { Bars3Icon, HeartIcon, ShoppingCartIcon, UserIcon, XMarkIcon, CubeIcon, ArrowRightOnRectangleIcon, UserPlusIcon } from "@heroicons/react/24/outline";
import { DropDownMenu } from "../export";
import { useNavigate, Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { loggedInUser } from "../../features/Auth/Auth_Slice";
import { userInfo } from "../../features/User/userSlice";
import { navigation } from "./ProductCategoryNavbar";


const dropDownMenuList = [
  {
    name: "My Profile",
    icon: <UserIcon className="w-5 h-5 text-gray-700 group-hover:text-gray-900" />,
    url: "/account"
  },
  {
    name: "Orders",
    icon: <CubeIcon className="w-5 h-5 text-gray-700 group-hover:text-gray-900" />,
    url: "/account/orders"
  },
  {
    name: "Wishlist",
    icon: <HeartIcon className="w-5 h-5 text-gray-700 group-hover:text-gray-900" />,
    url: "/account/wishlist"
  }
];

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function Header() {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const user = useSelector(loggedInUser);
  const userDetails = useSelector(userInfo);
  const [searchTerm, setSearchTerm] = useState("");

  const handleSearch = (e) => {
    e.preventDefault();
    if (searchTerm.trim()) {
      // User ko QueryPage par redirect query ke saath
      navigate(`/search?q=${searchTerm}`);
    }
  };

  const handleClearSearch = () => {
    setSearchTerm("");
    navigate("/");
  };

  const cartItemsLength = useSelector(state => state.cart.itemsLength)
  return (
    <div className="bg-white">
      {/* Mobile menu */}
      <Transition.Root show={open} as={Fragment}>
        <Dialog as="div" className="relative z-40 lg:hidden" onClose={setOpen}>
          <Transition.Child as={Fragment} enter="transition-opacity ease-linear duration-300" enterFrom="opacity-0" enterTo="opacity-100" leave="transition-opacity ease-linear duration-300" leaveFrom="opacity-100" leaveTo="opacity-0" >
            <div className="fixed inset-0 bg-black bg-opacity-25" />
          </Transition.Child>
          <div className="fixed inset-0 z-20 flex">
            <Transition.Child as={Fragment} enter="transition ease-in-out duration-300 transform" enterFrom="-translate-x-full" enterTo="translate-x-0" leave="transition ease-in-out duration-300 transform" leaveFrom="translate-x-0" leaveTo="-translate-x-full" >
              <Dialog.Panel className="relative  flex w-full max-w-xs flex-col overflow-y-auto bg-white pb-12 shadow-xl">
                <div className="flex px-4 pb-2 pt-5">
                  <button type="button" className="relative -m-2 inline-flex items-center justify-center rounded-md p-2 text-gray-400" onClick={() => setOpen(false)} >
                    <span className="absolute -inset-0.5" />
                    <span className="sr-only">Close menu</span>
                    <XMarkIcon className="h-6 w-6" aria-hidden="true" />
                  </button>
                </div>
                {/* Links */}
                <Tab.Group as="div" className="mt-2">
                  <div className="border-b border-gray-200">
                    <Tab.List className="-mb-px flex space-x-8 ">
                      {/* only showing men and women category */}
                      {navigation.categories.map((category) => {
                        return (category.id === "men" || category.id === "women") ? <Tab
                          key={category.name}
                          className={({ selected }) =>
                            classNames(
                              selected
                                ? "border-indigo-600 text-indigo-600"
                                : "border-transparent text-gray-900",
                              "flex-1 whitespace-nowrap border-b-2 px-1 py-4 text-base font-medium"
                            )
                          }
                        >
                          {category.name}
                        </Tab> : ""
                      }
                      )}
                    </Tab.List>
                  </div>
                  <Tab.Panels as={Fragment}>
                    {navigation.categories.map((category) => (
                      <Tab.Panel key={category.name} className="space-y-10 px-4 pb-8 pt-10" >
                        <div className="grid grid-cols-2 gap-x-4">
                          {category.featured.map((item) => (
                            <div key={item.name} className="group relative text-sm" >
                              <div className="aspect-h-1 aspect-w-1 overflow-hidden rounded-lg bg-gray-100 group-hover:opacity-75">
                                <img src={item.imageSrc} alt={item.imageAlt} className="object-cover object-center" />
                              </div>
                              <Link to={item.href} className="mt-6 block font-medium text-gray-900" >
                                <span className="absolute inset-0 z-10" aria-hidden="true" />
                                {item.name}
                              </Link>
                              <p aria-hidden="true" className="mt-1">
                                Shop now
                              </p>
                            </div>
                          ))}
                        </div>
                        {category.sections.map((section) => (
                          <div key={section.name}>
                            <p id={`${category.id}-${section.id}-heading-mobile`} className="font-medium text-gray-900" >
                              {section.name}
                            </p>
                            <ul aria-labelledby={`${category.id}-${section.id}-heading-mobile`} className="mt-6 flex flex-col space-y-6" >
                              {section.items.map((item) => (
                                <li key={item.name} className="flow-root">
                                  <Link to={item.href} className="-m-2 block p-2 text-gray-500" >
                                    {item.name}
                                  </Link>
                                </li>
                              ))}
                            </ul>
                          </div>
                        ))}
                      </Tab.Panel>
                    ))}
                  </Tab.Panels>
                </Tab.Group>

                <div className="space-y-6 border-t border-gray-200 px-4 py-6">
                  {navigation.pages.map((page) => (
                    <div key={page.name} className="flow-root ">
                      <Link to={page.href} className="-m-2 flex items-center p-2 " >
                        <img src={page.imageSrc} className="block h-auto w-5 flex-shrink-0" alt={page.imageAlt} />
                        <span className="ml-3 block text-base font-medium text-gray-900">
                          {page.name}
                        </span>
                      </Link>
                    </div>
                  ))}
                </div>
                {!user && !user?.isAuthenticated &&
                  <div className="space-y-6 border-t border-gray-200 px-4 py-6">
                    <div className="flow-root">
                      <Link to="/login" className="-m-2 flex items-center p-2" onClick={() => setOpen(false)}>
                        <ArrowRightOnRectangleIcon className="block h-auto w-5 flex-shrink-0" />
                        <span className="ml-3 block text-base font-medium text-gray-900">
                          Log In
                        </span>
                      </Link>
                    </div>
                    <div className="flow-root">
                      <Link to="/register" className="-m-2 flex items-center p-2" onClick={() => setOpen(false)}>
                        <UserPlusIcon className="block h-auto w-5 flex-shrink-0" />
                        <span className="ml-3 block text-base font-medium text-gray-900">
                          Create Account
                        </span>
                      </Link>
                    </div>
                  </div>
                }
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </Dialog>
      </Transition.Root>
      {/* End Of Mobile menu */}
      {/* Main Navbar Section */}
      <header className="bg-white fixed top-0 z-40 w-full main-header border-b pb-1 border-gray-200">
        {/* {useLocation().pathname==="/" ? (document.body.classList.add("topSectionActive") ,<p className="flex h-8 w-full items-center justify-center bg-indigo-600 px-4 text-sm font-medium text-white sm:px-6 lg:px-8">
             Get free delivery on your first order
         </p>): document.body.classList.remove("topSectionActive")}  */}
        {/* End of Top Section */}
        <nav aria-label="Top" className="mx-auto w-full px-4 sm:px-6 lg:px-8  max-w-7xl">
          <div>
            <div className="flex flex-wrap h-16 items-center flex-row">
              {/* Mobile navigation hamburger */}
              <button type="button" className="relative rounded-md bg-white p-0 sm:p-2 text-gray-400 lg:hidden" onClick={() => setOpen(true)}>
                <span className="absolute -inset-0.5" />
                <span className="sr-only">Open menu</span>
                <Bars3Icon className="h-6 w-6" aria-hidden="true" />
              </button>
              {/* End Of Mobile navigation hamburger */}
              {/* Logo Section 1*/}
              <div className="ml-2 sm:ml-4 flex lg:ml-0 basis-2/5	 lg:basis-52 py-4 lg:py-0">
                <Link to="/">
                  <div className="flex ">
                    <img className="h-8 w-auto" src="/logo.svg" alt="logo" />
                    <h2 className="font-bold text-2xl px-1 text-gray-900">UpTrend</h2>
                  </div>
                </Link>
              </div>
              {/* End Logo */}
              {/* Search Bar Section 2 */}
              <div className="basis-full searchBar order-last lg:order-none py-0 lg:py-0 lg:flex lg:flex-1 lg:basis-2/5  mt-3 lg:mt-0	">
                <form className="w-full" onSubmit={handleSearch}>
                  <div className="flex">
                    {/* Search Dropdown menu Button */}
                    <div className="relative flex">
                      <select id="categories" className="flex-shrink-0 z-10 inline-flex items-center py-2.5 px-2 sm:px-4 text-sm font-medium text-left text-gray-900 bg-white border border-gray-300 rounded-l-lg hover:bg-white focus:ring-indigo-600 focus:border-indigo-600  focus:outline-none ">
                        <option defaultValue={"all"} >All </option>
                        {navigation.categories && navigation.categories.map((category) => (
                          <option key={category.id} value={category.id}>{category.name} </option>
                        ))}


                      </select>
                    </div>
                    {/* Search Dropdown menu Button */}
                    {/* Search Button */}
                    <div className="relative w-full group">
                      <input type="search" id="search-dropdown-desktop" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="hidden md:block p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-r-lg border-l-gray-50 border-l-2 border border-gray-300 focus:ring-indigo-600 focus:border-indigo-600" placeholder="Search for Products, Brands And More..." required />
                      {/* Mobile searchbar */}
                      <input type="search" id="search-dropdown-mobile" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)} className="block md:hidden p-2.5 w-full z-20 text-sm text-gray-900 bg-gray-50 rounded-r-lg border-l-gray-50 border-l-2 border border-gray-300 focus:ring-indigo-600 focus:border-indigo-600" placeholder="Search Products & Brands..." required />

                      {searchTerm && (
                        <button
                          type="button"
                          onClick={handleClearSearch}
                          className="absolute top-0 right-10 p-2.5 text-gray-400 hover:text-indigo-600 transition-colors h-full"
                        >
                          <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={2} stroke="currentColor" className="w-5 h-5">
                            <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
                          </svg>
                        </button>
                      )}
                      <button type="submit" className="absolute top-0 right-0 p-2.5 text-sm font-medium h-full text-white bg-indigo-600 rounded-r-lg border border-indigo-600 hover:bg-indigo-700 focus:ring-4 focus:outline-none focus:ring-indigo-300 ">
                        <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                          <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
                          />
                        </svg>
                        <span className="sr-only">Search</span>
                      </button>
                    </div>
                    {/*End Of Search Button */}
                  </div>
                </form>
              </div>
              {/* end of Search Bar Section 2 */}
              {/* Section 3 Header Signin+ Cart */}
              <div className="flex items-center justify-end basis-5/12	ml-auto  sm:basis-3/6	 lg:basis-1/3 px-0 lg:px-9">
                {/* Signin button */}
                <div className="flex lg:ml-2 lg:mr-5">
                  <DropDownMenu dropdownItemsList={dropDownMenuList} btnIcon={<UserIcon className="h-6 w-5 pb-1 mx-1" />} caretSvg={true}>{user && user?.isAuthenticated ? userDetails?.firstname.toUpperCase() : "Sign In"}</DropDownMenu>
                </div>
                {/* Cart */}
                <div className="ml-4 flow-root lg:ml-4 ">
                  <Link to="/cart" className="group -m-2 flex items-center p-2">
                    <ShoppingCartIcon className="h-6 w-6 mr-1 flex-shrink-0 text-gray-400 group-hover:text-gray-500" aria-hidden="true" />
                    {cartItemsLength > 0 &&
                      <span className="inline-flex justify-center items-center rounded-xl bg-indigo-600 mb-5 -ml-4 text-xs font-medium text-white ring-1 ring-inset ring-indigo-700/10 w-[18px] h-[18px]">
                        {cartItemsLength}
                      </span>
                    }
                    <h3 className="text-sm font-medium text-gray-700 hover:text-gray-800">Cart</h3>
                  </Link>
                </div>
                {/* end of Cart */}
              </div>
              {/*end of Section 3 Header Signin+ Cart */}
            </div>
          </div>
        </nav>
        {/* End of navbar */}
      </header>
      
    </div>
  );
}
